import React from 'react';
import { useState, useEffect } from 'react';
import { PERMISSION_COORDINATOR, PERMISSION_SUBSCRIPTION_USER, PERMISSION_APPROVED_DRIVER, PERMISSION_TRADITIONAL_USER } from '../../shared/permissions/permissions';

import AlertIcon from '../../_styles/images/AlertIcon.png';
import { Link } from 'react-router-dom';
import { RestrictTo, isAllowed } from '../../shared/permissions/RestrictTo';
import dateUtility from '../../shared/dateUtility';
import { numberWithCommas } from '../../join-commute/helpers/commonHelper';
import rightArrow from '../../_styles/images/rightArrow.png';
import analyticsService from '../../shared/analytics/analytics-service';
import WarningAlert from '../../_styles/images/new-icons/black-warning.png';

export default function MainteanceAlert(props) {
  const { vehicleDetails, vanpoolStatus } = props;

  const SUBSCRIPITON_VANPOOL_MILEAGE_UPDATE = [
    [PERMISSION_SUBSCRIPTION_USER, PERMISSION_APPROVED_DRIVER],
    [PERMISSION_SUBSCRIPTION_USER, PERMISSION_COORDINATOR]
   ];

   const EVERYDAY_VANPOOL_MILEAGE_UPDATE = [
    [PERMISSION_TRADITIONAL_USER, PERMISSION_COORDINATOR]
   ]

  function handleClick() {
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "maintenance"
      }
    });
  }

  return (
    // <div className="other-information">
    <>
      {vanpoolStatus === 'P' || vanpoolStatus === 'A' ? null :<div className="maintenance-due">
        <div className="alert-icon">
          <img src={WarningAlert} alt="Alert Icon"></img>
        </div>
        <div className="middle-container">
          <div  className='first-section'>
            <h3>Preventative Maintenance Due</h3>
            <div className="due-on">
              Due on{' '}
              <span>
                {dateUtility.parseDateAsMonthDayYear(
                  vehicleDetails.nextScheduledMaintenanceDate
                )}{' '}
              </span>{' '}
              or at{' '}
              <span>{numberWithCommas(vehicleDetails.nextScheduledMaintenanceOdometer)} mi</span>
            </div>
            <div className="last-completed">
              Last completed on{' '}
              <span>
                {dateUtility.parseDateAsMonthDayYear(
                  vehicleDetails.lastPreventativeMaintenanceOdometerDate
                )}{' '}
              </span>{' '}
              at{' '}
              <span>{numberWithCommas(vehicleDetails.lastPreventativeMaintenanceOdometer)} mi</span>
            </div>
          </div>
          {
          ( isAllowed(SUBSCRIPITON_VANPOOL_MILEAGE_UPDATE) ||
          isAllowed(EVERYDAY_VANPOOL_MILEAGE_UPDATE)) && 
          <div className="view-container" onClick={() => handleClick()}>
          <Link className="view-desktop" to="/vanpool/maintenance" tabIndex={0}>
            View
          </Link>
          <img className="view-mobile"  onClick={() =>  props.history.push("/vanpool/maintenance")} tabIndex={0} src={rightArrow} alt={'view right arrow'} ></img>
          </div>
          }

        </div>
      </div> }
    </>
    // </div>
  );
}
